// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {}

export const mutations = {}

export const actions = {
  getTransactions(_, payload) {
    return ApiService.getTransactions(payload)
      .then((res) => {
        const transactions = res.data.data
        return transactions
      })
      .catch((error) => {
        throw error
      })
  },
}
